export default {
  settings: 'Paramètres',
  storefront: 'Vitrine',
  media: 'Médias',
  style: 'Style',
  scripts: 'Scripts',
  no_google_place: {
    title: "La société n'est connectée à aucun établissement Google",
    description: 'Veuillez connecter la société à un établissement Google',
  },
};
